import { type Theme, useTheme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { TileSkeleton } from '#components/Tile/Skeleton.tsx';
import { CarouselScrollContainer, SkeletonCarouselContainer, TileContainer } from './styled.ts';

export type TileCarouselSkeletonProps = {
  imageType?: 'backdrop' | 'poster';
  items?: number;
  tileContainerSx?: SystemStyleObject<Theme>;
};

export const TileCarouselSkeleton = ({ imageType, items = 7, tileContainerSx }: TileCarouselSkeletonProps) => {
  const theme = useTheme();

  return (
    <SkeletonCarouselContainer>
      <CarouselScrollContainer>
        {Array.from({ length: items }).map((_, index) => (
          <TileContainer
            key={index}
            sx={
              tileContainerSx ?? {
                [theme.breakpoints.down('sm')]: {
                  width: '120px',
                },
                marginRight: theme.spacing(2),
                width: '180px',
              }
            }
          >
            <TileSkeleton imageType={imageType} orientation="vertical" />
          </TileContainer>
        ))}
      </CarouselScrollContainer>
    </SkeletonCarouselContainer>
  );
};
